export default __webpack_public_path__ + "static/Medicare-new-eb8bbbe42b2e5407b3b98f71be4a0f6b.jpg";